"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.includesNaN = void 0;
/**
 * Performance optimized version of `Array.prototype.includes` method for testing `NaN` value.
 *
 * Determines whether an array includes NaN value among its entries,
 * returning true or false as appropriate.
 *
 * @see https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/includes
 *
 * @param {Array} array - Input array.
 * @param {number} [fromIndex=0] - Index to start search from.
 *
 * @return {boolean}
 *
 * @example
 * import { includesNaN } from '@24i/appstage-shared-perf-utils/dist/array';
 *
 * // returns true
 * includesNaN([0, NaN, 2]);
 *
 * // returns false
 * includesNaN([0, NaN, 2], 2);
 */
const includesNaN = (array, fromIndex = 0) => {
    for (let i = fromIndex, len = array.length; i < len; i++) {
        const iValue = array[i];
        // eslint-disable-next-line no-self-compare
        if (iValue !== iValue) {
            // true only for NaN value
            return true;
        }
    }
    return false;
};
exports.includesNaN = includesNaN;
